export default class {
    constructor (component, eventObject) {

        this.#component = component;
        this.#events = eventObject?.events;
        this.#subscriptions = eventObject?.subscriptions;

        this.addEvents();
    }

    // Static

    static globalEvents = {
        // valuechange not formatted for backwards compatibility
        ValueChanged: 'valuechange',
        ClosedToggled: 'closed-toggled',
        DisabledToggled: 'disabled-toggled'
    }

    // Public

    addEvents (events) {
        this.#initialiseEvents(events?.events);
        this.#initialiseSubscriptions(events?.subscriptions);
    }

    // Private

    #eventSubscribeAttribute = 'event_subscribe';
    #component = null;
    #events = {};
    #subscriptions = {};

    #initialiseEvents (events = this.#events) {
        if (!events) {
            return;
        }

        for (const [key, eventName] of Object.entries(events)) {
            this[key] = {
                dispatch: (data, dispatchOnSubscribers, subscriberRoot) => this.#dispatch(eventName, data, dispatchOnSubscribers, subscriberRoot),
                name: eventName
            };
        }
    }

    #initialiseSubscriptions (subscriptions = this.#subscriptions) {
        if (!subscriptions) {
            return;
        }

        for (const [eventName, callback] of Object.entries(subscriptions)) {
            this.#component.addEventListener(eventName, callback);
        }

        const subscriptionKeys = new Set();
        const alreadyAddedSubscriptions = this.#component.getAttribute(this.#eventSubscribeAttribute);

        if (alreadyAddedSubscriptions) {
            subscriptionKeys.add(...alreadyAddedSubscriptions.split(' '));
        }

        subscriptionKeys.add(...Array.from(Object.keys(subscriptions)));

        if (this.#component.isConnected) {
            this.#addSubscriptionAttribute(subscriptionKeys);
        } else {
            // Add subscription attribute on Connected Callback if node is not connected
            // to avoid the node having attribute prior to construction (forbidden)
            this.#component.onConnectedCallback = () => this.#addSubscriptionAttribute(subscriptionKeys);
        }
    }

    #addSubscriptionAttribute (subscriptionKeys) {
        this.#component.setAttribute(this.#eventSubscribeAttribute, Array.from(subscriptionKeys).join(' '));
    }

    #dispatch (eventName, data, dispatchOnSubscribers = false, subscriberRoot) {
        this.#component.dispatchEvent(new CustomEvent(eventName, {detail: data}));

        if (dispatchOnSubscribers) {
            this.#dispatchOnSubscribedChildren(eventName, data, subscriberRoot);
        }
    }

    #dispatchOnSubscribedChildren (eventName, data, subscriberRoot = this.#component) {
        const subscribedChildren = subscriberRoot.querySelectorAll(`[${this.#eventSubscribeAttribute}*="${eventName}"]`);

        [...subscribedChildren].forEach((child) => child.dispatchEvent(new CustomEvent(eventName, {detail: data})));
    }
}